<template>
  <div class="contacts">
    <div class="content">

      <div class="wrap">
        <div class="wrap__tree">
          <div class="nav-tree">
            <h3>Contacts Xero</h3>
            <el-dropdown @command="handleCommand">
              <el-button style="margin-right: 0px;" class="nav-tree__item" size="small" type="menu" icon="el-icon-edit-outline">Action</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="createContact" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add Contacts</el-dropdown-item>
                <el-dropdown-item :disabled="!currentRow" command="updateContact" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit">Edit Contacts</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <el-table
            :data="tableData.filter(data => !search || data.Name.toLowerCase().includes(search.toLowerCase()))"
            :empty-text="$t('general_noData')"
            highlight-current-row
            @current-change="handleCurrentChange"
            height="96%"
            size="medium"
            style="width: 100%">
            <el-table-column
              type="index"
              width="50">
            </el-table-column>
            <el-table-column
              prop="Name"
              label="Name">
            </el-table-column>
            <el-table-column
              prop="date"
              label="Date"
              width="180">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="search"
                  size="mini"
                  placeholder="Type to search"/>
              </template>
              <template slot-scope="scope">
                {{ formatDate(scope.row.UpdatedDateUTC) }}
              </template>
            </el-table-column>
          </el-table>

        </div>

        <div class="wrap__info">
          <div class="wrap__info-tab">

          <div style="margin-bottom: 10px;">
            <el-dropdown placement="bottom-start">
              <el-button disabled size="small" type="menu" icon="el-icon-edit-outline">Function</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_projectBookmark')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

            <el-tabs v-model="activeTabName" disabled type="border-card" @tab-click="handleClick">
              <el-tab-pane label="Info" name="info">
                <el-card shadow="hover">
                  Info...
                </el-card>
              </el-tab-pane>
            </el-tabs>

          </div>
        </div>

      </div>

      <create-update-modal @loadList="loadList" ref="createUpdateModal"></create-update-modal>

    </div>
  </div>
</template>

<script>
let moment = require('moment')
import axios from 'axios'
import CreateUpdateModal from '@/views/contactsXero/components/CreateUpdateModal.vue'
export default {
  name: 'ContactsXero',
  components: {
    CreateUpdateModal,
  },
  mounted() {
    this.loadList()
  },
  computed: {
    rowData() {
      return this.$store.getters.getRowDataVendors
    },
    companyLayout() {
      return this.$store.state.companyLayout
    }
  },
  data() {
    return {
      moment: moment,

      // table
      tableData: [],
      currentRow: null,
      search: '',

      activeTabName: 'info'
    }
  },
  methods: {
    async loadList() {
      let loader = this.$loading.show()
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/xero/contacts/list?companyId=${this.$route.query.companyId}`)
        this.tableData = data.list
        loader.hide()
      } catch (error) {
        console.log('An error occurred:', error)
        loader.hide()
      }
    },
    handleCurrentChange(val) {
      console.log("🚀 ~ file: ContactsXero.vue:130 ~ handleCurrentChange ~ val:", val)
      this.currentRow = val
    },
    handleCommand(command){
      switch (command) {
        case 'createContact':
          this.openModalCreate()
          break;
        case 'updateContact':
          this.openModalUpdate()
          break;
      }
    },
    openModalCreate() {
      this.$refs.createUpdateModal.openModal({ isCreate: true })
    },
    openModalUpdate() {
      this.$refs.createUpdateModal.openModal({ isCreate: false, currentRow: this.currentRow })
    },
    formatDate(dateString) {
      const timestamp = parseInt(dateString.match(/\d+/)[0])
      return moment(timestamp, 'x').format('D MMM YY')
    },
    handleClick(tab, event) {
      if(tab.name === 'vendorFiles'){
        this.$store.dispatch('getVendorsFiles')
      } else if (tab.name ==='vendorPersonFiles') {
        this.$store.dispatch('getVendorsPersonsFiles')
      } else if (tab.name === 'vendorComment') {
        this.$refs['vendorComment'].loadList()
      } else if (tab.name === 'vendorMeetings') {
        this.$refs['vendorMeetings'].loadList()
      } else if (tab.name === 'vendorPersonsMeetings') {
        this.$refs['vendorPersonsMeetings'].loadList()
      } else if (tab.name === 'at') {
        this.$refs['vendorAT'].openTab()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.contacts {
  background: #DfE8F0;
  height: 100vh;
}
.content {
  display: flex;
  height: 100vh;
  padding-top: 50px;
}
.wrap {
  display: flex;
  width: 100%;
  padding: 20px 10px 10px 10px;

  &__tree {
    width: 35%;
    padding: 0 10px 10px 0;
  }
  &__info {
    display: flex;
    flex-direction: column;
    width: 65%;
    padding: 0 0 0 10px;
  }
  &__info-tab {
    height: 100%;
    margin-top: 0px;
    overflow-y: auto;
    .isEmpty {
      color: #ccc
    }
    &_label {
      display: inline-block;
      width: 200px;
    }
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      color: #888;
      li {
        margin-bottom: 8px;
        span {
          font-weight: 500;
        }
      }
    }
  }
}
.nav-tree {
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
  }
  &__item {
    margin: 0 0 5px 0;
  }
  .el-button {
    margin-right: 10px;
  }
}
.el-tabs--border-card {
  height: 100%;
  overflow-x: hidden;
  /deep/.el-tabs__content {
    height: 100% !important;
  }
}
</style>
